import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/Login";
import RegisterPage from "./pages/RegisterPage";
import LegalPage from "./pages/LegalPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Annuaire from "./pages/Annuaire";
import Opportunites from "./pages/Opportunites";
import Avantages from "./pages/Avantages";
import CreateBenefit from "./pages/CreateBenefit";
import Evenements from "./pages/Evenements";
import EventDetail from "./pages/EventDetail";
import MesStatistiques from "./pages/MesStatistiques";
import Dashboard from "./pages/Dashboard";
import Demarrage from "./pages/Demarrage";
import ProfileDetail from "./pages/ProfileDetail";
import MonProfil from "./pages/MonProfil";
import PostOpportunite from "./pages/PostOpportunite";
import Prospects from "./pages/Prospects";
import Nouveautes from "./pages/Nouveautes";
import ParametresPage from "./pages/ParametresPage";
import AdminPanel from "./pages/admin/AdminPanel";
import Layout from "./components/Layout";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#0D1B3E" }}>
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-gold border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-cbm-muted text-sm">Chargement...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register/:token" element={<RegisterPage />} />
            <Route path="/conditions" element={<LegalPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/demarrage" element={<ProtectedRoute><Demarrage /></ProtectedRoute>} />
            <Route path="/annuaire" element={<ProtectedRoute><Annuaire /></ProtectedRoute>} />
            <Route path="/annuaire/:id" element={<ProtectedRoute><ProfileDetail /></ProtectedRoute>} />
            <Route path="/prospects" element={<ProtectedRoute><Prospects /></ProtectedRoute>} />
            <Route path="/nouveautes" element={<ProtectedRoute><Nouveautes /></ProtectedRoute>} />
            <Route path="/opportunites" element={<ProtectedRoute><Opportunites /></ProtectedRoute>} />
            <Route path="/avantages" element={<ProtectedRoute><Avantages /></ProtectedRoute>} />
            <Route path="/avantages/new" element={<ProtectedRoute><CreateBenefit /></ProtectedRoute>} />
            <Route path="/evenements" element={<ProtectedRoute><Evenements /></ProtectedRoute>} />
            <Route path="/events/:id" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} />
            <Route path="/mes-statistiques" element={<ProtectedRoute><MesStatistiques /></ProtectedRoute>} />
            <Route path="/profil/:id" element={<ProtectedRoute><ProfileDetail /></ProtectedRoute>} />
            <Route path="/mon-profil" element={<ProtectedRoute><MonProfil /></ProtectedRoute>} />
            <Route path="/parametres" element={<ProtectedRoute><ParametresPage /></ProtectedRoute>} />
            <Route path="/poster-annonce" element={<ProtectedRoute><PostOpportunite /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPanel /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
